/* eslint-disable no-console */
/**
 * Use these helpers to send messages to server
 */
export const consoleHelpers = {
  log(...messages) {
    console.log(...messages);
    // logService.log(stringifyMessages(messages), LogLevels.INFORMATION);
  },
  warn(...messages) {
    console.warn(...messages);
    // logService.log(stringifyMessages(messages), LogLevels.INFORMATION);
  },
  error(...messages) {
    console.error(...messages);
    // logService.log(stringifyMessages(messages), LogLevels.ERROR);
  },
  debug(...messages) {
    console.debug(...messages);
  },
};
